// This file is used for local serve and development builds (`ng build --configuration=development`).
// Production builds replace this file with environment.prod.ts (see angular.json).

export const environment = {
  production: false,
  domain_url: 'https://dev-choppies.scanmyinvoice.com',
  trial_auth_url: 'https://trial-api.scanmyinvoice.com',
  auth_url: 'https://dev-choppies-api.scanmyinvoice.com',
  dashboard_url: '',
  logoVersion: '20260613',
};

// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
